export type CRISRegion = 'US' | 'EU' | 'APAC' | 'Japan' | 'Australia' | 'Canada' | 'Global';

export function extractCRISRegion(profileId: string): CRISRegion | undefined {
  if (profileId.startsWith('us.')) return 'US';
  if (profileId.startsWith('eu.')) return 'EU';
  if (profileId.startsWith('apac.')) return 'APAC';
  if (profileId.startsWith('jp.')) return 'Japan';
  if (profileId.startsWith('au.')) return 'Australia';
  if (profileId.startsWith('ca.')) return 'Canada';
  if (profileId.startsWith('global.')) return 'Global';
  return undefined;
}

export function matchesCRISRegion(
  profileId: string,
  sourceRegion: string | null | undefined,
  destinations: string[] | null | undefined,
  target: CRISRegion,
  regionalGroup?: string
): boolean {
  const cris = extractCRISRegion(profileId);
  if (cris) {
    return cris === target;
  }

  // Handle nullable regions for non-AWS providers
  if (!sourceRegion && (!destinations || destinations.length === 0)) {
    // No region info available, match only if target is Global
    return target === 'Global';
  }

  const regionList = [
    ...(sourceRegion ? [sourceRegion] : []),
    ...(destinations || [])
  ];

  switch (target) {
    case 'US':
      return regionList.some((region) => region.startsWith('us-'));
    case 'EU':
      return regionList.some((region) => region.startsWith('eu-'));
    case 'Japan':
      return regionList.some((region) => region === 'ap-northeast-1' || region === 'ap-northeast-3');
    case 'Australia':
      return regionList.some((region) => region === 'ap-southeast-2');
    case 'Canada':
      return regionList.some((region) => region.startsWith('ca-'));
    case 'APAC':
      return regionList.some((region) => region.startsWith('ap-'));
    case 'Global':
      return regionalGroup === 'Global';
    default:
      return false;
  }
}
